import React from 'react';
import { Link } from 'react-router-dom';
import brandLogo from '../images/WhatsApp Image 2026-05-17 at 11.51.42 AM.jpeg';

const ProductCard = ({ product, showDescription = true, centerTitle = false, imageFit = 'contain', to }) => {
  const cardContent = (
    <div className="home-product-card">
      <div className="home-product-card__image">
        {product.image ? (
          <img src={product.image} alt={product.name} className={imageFit === 'cover' ? 'home-fit-cover' : 'home-fit-contain'} />
        ) : (
          <img src={brandLogo} alt="Brand Logo" className="home-product-card__logo" />
        )}
      </div>
      <div className={`home-product-card__body${centerTitle ? ' home-product-card__body--center' : ''}`}>
        <h3 className={`home-product-card__name${centerTitle ? ' home-product-card__name--center' : ''}`}>{product.name}</h3>
        {showDescription && product.description ? (
          <p className="home-product-card__description">{product.description}</p>
        ) : null}
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="home-product-card-link" aria-label={`Open ${product.name} page`}>
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};

export default ProductCard;
